function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { selectForNamedScreenSize, useScreenSize } from '../../../hooks';
import { buildClassNames } from '../../../modules/css-helpers';
import { createOwnUpComponent } from '../../components';
import { OwnUpColumnsStyle, OwnUpRowStyle } from './style';

/**
 * Iterates over children and separates them into
 *   ReactNodeArrays based on counts.
 *
 * @param children - Children to render.
 * @param screenSize - Current screen size
 * @param count - Row count params
 */
var getChildren = function getChildren(children, perRow) {
  var sets = [];

  if (Array.isArray(children)) {
    // If a count is set...
    if (perRow) {
      // Separate the children by column counts
      for (var i = 0; i < children.length; i += perRow) {
        sets.push(children.slice(i, i + perRow));
      }
    } else {
      // If count is undefined, just push the children.
      sets.push(children);
    }
  } else {
    // If children is a single element, just push that.
    sets.push([children]);
  }

  return sets;
};

var StyledRow = createOwnUpComponent('div', OwnUpRowStyle);
/**
 * Wraps sets in row elements.
 *
 * @param children - Children to render.
 * @param classes  - ClassNames for rows
 */

var renderChildren = function renderChildren(children, classes, variant, perRow) {
  // Wrap each set in a row container
  var elements = children.map(function (set, i) {
    return /*#__PURE__*/React.createElement(StyledRow, {
      className: classes,
      variant: variant,
      key: "cols-".concat(i),
      perRow: perRow
    }, set);
  }); // Return the item set.

  return /*#__PURE__*/React.createElement(React.Fragment, null, elements);
};

var StyledContainer = createOwnUpComponent('div', OwnUpColumnsStyle);
/**
 * An Own Up branded columns. Can be capped out by
 *   specifying the column count and at which
 *   screen sizes.
 *
 * @param props - See {@link OwnUpColumnsProps}
 */

export var OwnUpColumns = function OwnUpColumns(_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      rowClassName = _ref.rowClassName,
      rowVariant = _ref.rowVariant,
      count = _ref.count,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "variant", "rowClassName", "rowVariant", "count", "children"]);

  var rowClasses = buildClassNames('ou-columns__row', className);
  var containerClasses = buildClassNames('ou-columns', rowClassName);
  var screenSize = useScreenSize(); // ... determine the number of columns per row based on
  //   the count and screen size.

  var perRow;

  if (typeof count === 'number' || typeof count === 'string') {
    perRow = Number(count);
  } else if (count) {
    perRow = selectForNamedScreenSize(screenSize, count) || 1;
  }

  var sets = getChildren(children, perRow);
  var rows = renderChildren(sets, rowClasses, rowVariant, perRow);
  return /*#__PURE__*/React.createElement(StyledContainer, _extends({
    className: containerClasses
  }, props), rows);
};